import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { Ng1LoadedGuard } from '../shared/ng1/ng1-loaded.guard';
import { AddressBookComponent } from './address-book.component';
import { AddressBookListComponent } from './address-book-list/address-book-list.component';
import { MsisdnResolver } from '../shared/msisdn/msisdn.resolver';

const routes: Routes = [
  {
    path: 'address-book',
    component: AddressBookComponent,
    canActivate: [Ng1LoadedGuard],
    canLoad: [NgxPermissionsGuard],
    children: [
      {
        path: '',
        component: AddressBookListComponent,
        resolve: {
          msisdns: MsisdnResolver
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AddressBookRoutingModule {}
